const coursesData = [
  { 
    id: "Chemistry 0620", 
    title: "Chemistry 0620",
    description:
      "This course is the Extended version, course prepares you for 3 final exams.",
    papers: [
      { label: "Paper 2 – Multiple Choice (Extended)", percentage: "30%" },
      { label: "Paper 4 – Theory (Extended)",        percentage: "50%" },
      { label: "Paper 6 – Alternative to Practical",  percentage: "20%" },
    ],
    topics: [
      "States of matter",
      "Atoms, elements and compounds",
      "Stoichiometry",
      "Electrochemistry",
      "Chemical energetics",
      "Chemical reactions",
      "Acids, bases and salts",
      "The Periodic Table",
      "Metals & chemistry of the environment",
      "Organic chemistry",
    ],
  },
  { 
    id: "Biology 0610",
    title: "Biology 0610",
    description:
      "This course is the Extended version, course prepares you for 3 final exams.",
    papers: [
      { label: "Paper 2 – Multiple Choice (Extended)", percentage: "30%" },
      { label: "Paper 4 – Theory (Extended)",        percentage: "50%" },
      { label: "Paper 6 – Alternative to Practical",  percentage: "20%" },
    ],
    topics: [
      "Characteristics and classification of living organisms",
      "Organization of the organism & movement into and out of cells",
      "Biological molecules & enzymes",
      "Plant nutrition & human nutrition",
      "Transport in plants & transport in animals",
      "Diseases and immunity & gas exchange in humans",
      "Respiration & excretion in humans & coordination and response & drugs",
      "Reproduction & inheritance & variation and selection",
      "Organisms and their environment & human influences on ecosystems",
      "Biotechnology and genetic modification",
    ],
  },
  {
    id: "Additional Mathematics 0606", 
    title: "Additional Mathematics 0606",
    description:
      "This course prepares you for two final exams.",
    papers: [
      { label: "Paper 1", percentage: "50%" },
      { label: "Paper 2", percentage: "50%" },
    ],
    topics: [
      "Functions & quadratic functions",
      "Equations, inequalities & graphs",
      "Indices & surds",
      "Factors of polynomials",
      "Simultaneous equations",
      "Logarithmic & exponential functions",
      "Straight line graphs",
      "Circular measure & trigonometry",
      "Permutations & combinations & series",
      "Vectors in two dimensions & differentiation & integration",
    ],
  },
  { 
    id: "Information & Communication Technology 0417", 
    title: "Information & Communication Technology 0417",
    description:
      "This course prepares you for three final exams: one theory and two practicals.",
    papers: [
      { label: "Paper 1 – Theory",    percentage: "40%" },
      { label: "Paper 2 – Practical", percentage: "30%" },
      { label: "Paper 3 – Practical", percentage: "30%" },
    ],
    topics: [
      "Microsoft Word (software)",
      "Microsoft Excel (software)",
      "Microsoft PowerPoint (software)",
      "Microsoft Access (software)",
      "Microsoft Expression Web 4 (software)",
      "Editing report documents in Word",
      "Creating spreadsheets & designing in Excel",
      "Creating reports from datasets",
      "Building web pages with HTML & CSS",
      "Theory topics from the syllabus",
    ],
  },
  {
    id: "Mathematics 0580",
    title: "Mathematics 0580",
    description:
      "This course is the Extended version of IGCSE Mathematics 0580.",
    papers: [
      { label: "Paper 2 – Extended", percentage: "35%" },
      { label: "Paper 4 – Extended", percentage: "65%" },
    ],
    topics: [
      "Number",
      "Algebra & graphs",
      "Coordinate geometry",
      "Geometry",
      "Mensuration",
      "Trigonometry",
      "Vectors & transformations",
      "Probability",
      "Statistics",
    ],
  },
  { 
    id: "Physics 0625",
    title: "Physics 0625",
    description:
      "This course is the Extended version, course prepares you for 3 final exams.",
    papers: [
      { label: "Paper 2 – Multiple Choice (Extended)", percentage: "30%" },
      { label: "Paper 4 – Theory (Extended)",         percentage: "50%" },
      { label: "Paper 6 – Alternative to Practical",   percentage: "20%" },
    ],
    topics: [
      "Motion, forces & energy",
      "Thermal physics",
      "Waves",
      "Electricity & magnetism",
      "Nuclear physics",
    ],
  },
  { 
    id: "English as a Second Language 0510",
    title: "English as a Second Language 0510",
    description:
      "This course prepares you for two final exams in ESL.",
    papers: [
      { label: "Paper 2 – Reading & Writing", percentage: "70%" },
      { label: "Paper 4 – Listening",        percentage: "30%" },
    ],
    topics: [
      "Reading",
      "Writing",
      "Listening",
      "Speaking practice papers",
    ],
  },
  { 
    id: "Business Studies 0450",
    title: "Business Studies 0450",
    description:
      "This course prepares you for two final exams in Business Studies.",
    papers: [
      { label: "Paper 1 – Short Answer & Data Response (1h 30m)", percentage: "50%" },
      { label: "Paper 2 – Case Study (1h 30m)",                   percentage: "50%" },
    ],
    topics: [
      "Understanding business activity",
      "People in business & marketing",
      "Operations management",
      "Financial information & decisions",
      "External influences on business activity",
    ],
  },
  { 
    id: "Computer Science 0478",
    title: "Computer Science 0478",
    description:
      "This course prepares you for two final exams in Computer Science.",
    papers: [
      { label: "Paper 1 – Theory (1h 45m)",                   percentage: "60%" },
      { label: "Paper 2 – Problem‐solving & Programming (1h 45m)", percentage: "40%" },
    ],
    topics: [
      "Data representation",
      "Communication & internet technologies",
      "Hardware & software",
      "Security",
      "Ethics",
      "Algorithm design & problem‐solving",
      "Programming",
      "Databases", 
    ],
  },
  /*{
    title: "Economics 0455",
    description:
      "This course prepares you for two final exams in Economics.",
    papers: [
      { label: "Paper 1 – Multiple Choice", percentage: "30%" },
      { label: "Paper 2 – Data Response & Essay", percentage: "70%" },
    ],
    topics: [
      "The basic economic problem & approach",
      "Role of markets",
      "Government in the economy",
      "International trade",
      "Development issues",
    ],
  },
  {
    title: "Accounting 0452",
    description:
      "This course prepares you for two final exams in Accounting.",
    papers: [
      { label: "Paper 1 – Multiple Choice", percentage: "40%" },
      { label: "Paper 2 – Theory & Practical Tasks", percentage: "60%" },
    ],
    topics: [
      "Purpose & role of accounting",
      "Principles & concepts",
      "Recording financial transactions",
      "Control accounts & error correction",
      "Incomplete records",
      "Financial statements",
      "Partnerships",
      "Interpretation of accounts",
      "Cash flow",
    ],
  }*/
  { 
    id: "Environmental Management 0680",
    title: "Environmental Management 0680",
    description:
      "This course prepares you for two final exams in Environmental Management.",
    papers: [
      { label: "Paper 1 – Multiple Choice", percentage: "30%" },
      { label: "Paper 2 – Structured Questions", percentage: "70%" },
    ],
    topics: [
      "The natural environment",
      "Resource management",
      "Pollution",
      "Sustainable development",
      "Conservation",
      "Human impact & ecosystems",
      "Global environmental issues",
    ],
  },
  { 
    id: "English First Language 0500",
    title: "English First Language 0500",
    description:
      "This course prepares you for three final exams in First‐Language English.",
    papers: [
      { label: "Paper 1 – Reading Passage", percentage: "50%" },
      { label: "Paper 3 – Listening",        percentage: "25%" },
      { label: "Paper 5 – Speaking",         percentage: "25%" },
    ],
    topics: [
      "Reading comprehension",
      "Writing skills",
      "Listening skills",
      "Speaking & communication",
    ],
  }, 

    {

    id: "As & A level Math",
    title: "As & A level Math",
    description:
      "A combined Cambridge AS & A level Mathematics course covering Pure Mathematics, Mechanics, and Probability & Statistics.",
    papers: [
      { label: "Paper 1 – Pure Mathematics 1 (1h 50m, 75 marks)", percentage: "60% AS / 30% A" },
      { label: "Paper 2 – Pure Mathematics 2 (1h 15m, 50 marks)", percentage: "40% AS" },
      { label: "Paper 3 – Pure Mathematics 3 (1h 50m, 75 marks)", percentage: "30% A" },
      { label: "Paper 4 – Mechanics (1h 15m, 50 marks)", percentage: "40% AS / 20% A" },
      { label: "Paper 5 – Probability & Statistics 1 (1h 15m, 50 marks)", percentage: "40% AS / 20% A" },
      { label: "Paper 6 – Probability & Statistics 2 (1h 15m, 50 marks)", percentage: "20% A" },
    ],
    topics: [
      "Pure Mathematics 1",
      "Pure Mathematics 2",
      "Pure Mathematics 3",
      "Mechanics",
      "Probability & Statistics 1",
      "Probability & Statistics 2",
    ],
  },
  { 
    id: "As & A level Physics",
    title: "As & A level Physics",
    description:
      "A combined Cambridge AS & A level Physics course emphasizing conceptual understanding and practical skills.",
    papers: [
      { label: "Paper 1 – Multiple Choice (1h 15m, 40 marks)", percentage: "31% AS / 15.5% A" },
      { label: "Paper 2 – AS Structured Questions (1h 15m, 60 marks)", percentage: "46% AS / 23% A" },
      { label: "Paper 3 – Advanced Practical Skills (2h, 40 marks)", percentage: "23% AS / 11.5% A" },
      { label: "Paper 4 – A Level Structured Questions (2h, 100 marks)", percentage: "38.5% A" },
      { label: "Paper 5 – Planning, Analysis & Evaluation (1h 15m, 30 marks)", percentage: "11.5% A" },
    ],
    topics: [
      // AS topics
      "Physical quantities and units",
      "Kinematics",
      "Dynamics",
      "Forces, density and pressure",
      "Work, energy and power",
      "Deformation of solids",
      "Waves",
      "Superposition",
      "Electricity",
      "D.C. circuits",
      "Particle physics",
      // A level topics
      "Motion in a circle",
      "Gravitational fields",
      "Temperature",
      "Ideal gases",
      "Thermodynamics",
      "Deformation of solids (A level)",
      "Electric fields",
      "Capacitance",
      "Electricity (A level)",
      "Magnetic fields",
      "Alternating currents",
      "Nuclear physics",
      "Medical physics",
      "Astronomy and cosmology",
    ],
  },
  { 
    id: "As & A level Biology", 
    title: "As & A level Biology",
    description:
      "A combined Cambridge AS & A level Biology course covering key biological concepts from cells through ecosystems.",
    papers: [
      { label: "Paper 1 – Multiple Choice (1h 15m)", percentage: "30%" },
      { label: "Paper 2 – AS Structured Questions (1h 15m)", percentage: "50%" },
      { label: "Paper 3 – Advanced Practical Skills (2h)", percentage: "20%" },
    ],
    topics: [
      // AS topics
      "Cell structure",
      "Biological molecules",
      "Enzymes",
      "Cell membranes and transport",
      "The mitotic cell cycle",
      "Nucleic acids and protein synthesis",
      "Transport in plants",
      "Transport in mammals",
      "Gas exchange",
      "Infectious diseases",
      "Immunity",
      // A level topics
      "Energy and respiration",
      "Photosynthesis",
      "Homeostasis",
      "Control and coordination",
      "Inheritance",
      "Selection and evolution",
      "Classification, biodiversity and conservation",
      "Genetic technology",
    ],
  }, 
  { 
    id: "As & A level Chemistry", 
    title: "As & A level Chemistry",
    description:
      "A combined Cambridge AS & A level Chemistry course blending theory with practical skills.",
    papers: [
      { label: "Paper 1 – Multiple Choice (1h 15m)", percentage: "31% AS / 15.5% A" },
      { label: "Paper 2 – AS Structured Questions (1h 15m)", percentage: "46% AS / 23% A" },
      { label: "Paper 3 – Advanced Practical Skills (2h)", percentage: "23% AS / 11.5% A" },
      { label: "Paper 4 – A Level Structured Questions (2h)", percentage: "38.5% A" },
      { label: "Paper 5 – Planning, Analysis & Evaluation (1h 15m)", percentage: "11.5% A" },
    ],
    topics: [
      // AS topics
      "Atomic structure",
      "Atoms, molecules and stoichiometry",
      "Chemical bonding",
      "Chemical energetics",
      "Electrochemistry",
      "Equilibria",
      "Reaction kinetics",
      "The Periodic Table: chemical periodicity",
      "Group 1",
      "Group 2",
      "Nitrogen & Sulfur",
      "Hydrocarbons",
      "Halogen compounds",
      "Hydroxy compounds",
      "Carbonyl compounds",
      "Carboxylic acids and derivatives",
      "Nitrogen compounds",
      "Polymerisation",
      "Organic synthesis",
      // A level topics
      "Chemical energetics",
      "Electrochemistry (A level)",
      "Equilibria (A level)",
      "Reaction kinetics (A level)",
      "Inorganic Chemistry",
      "Hydrocarbons (A level)",
      "Halogen compounds (A level)",
      "Hydroxy compounds (A level)",
      "Carboxylic acids and derivatives (A level)",
      "Polymerisation (A level)",
      "Organic synthesis (A level)",
      "Analytical techniques",
    ],
  },
];

export default coursesData;

